import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XBCCommonRoutingModule } from './xbc-common-routing.module';
import { ResultGridComponent } from './result-grid/result-grid.component';
import { LinkCellRenderer } from './link-cell-renderer/link-cell-renderer.component';
import { AgGridModule } from 'ag-grid-angular';
import { ActionLinkCellRenderer } from './action-link-cell-renderer/action-link-cell-renderer.component';
import { ExportComponent } from './export/export.component';
import { CountryDropdownComponent } from './country-dropdown/country-dropdown.component';
import { CheckboxCellRendererComponent } from './checkbox-cell-renderer/checkbox-cell-renderer.component';
import { RspDropdownComponent } from './rsp-dropdown/rsp-dropdown.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { ReceivingChannelDropdownComponent } from './receiving-channel-dropdown/receiving-channel-dropdown.component';
import { TransactionStatusDropdownComponent } from './transaction-status-dropdown/transaction-status-dropdown.component'
import { CompanyDropdownComponent } from './company-dropdown/company-dropdown.component';
import { MultiActionLinkCellRendererComponent } from './multi-action-link-cell-renderer/multi-action-link-cell-renderer.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ResultGridActionsComponent } from './result-grid-actions/result-grid-actions.component';
import { CancelTransactionComponent } from './cancel-transaction/cancel-transaction.component';
import { MakerCheckerComponent } from './maker-checker/maker-checker.component';
import { MakerCheckerSearchPanelComponent } from './maker-checker-search-panel/maker-checker-search-panel.component';
import { MakerCheckerRequestDetailsPanelComponent } from './maker-checker-request-details-panel/maker-checker-request-details-panel.component';
import { MakerCheckerFilterFormComponent } from './maker-checker-filter-form/maker-checker-filter-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomDatePipe } from '../pipes/custom-date.pipe';
import { EmployeeDropdownComponent } from './employee-dropdown/employee-dropdown.component';

@NgModule({
  declarations: [
    ResultGridComponent,
    LinkCellRenderer,
    ActionLinkCellRenderer,
    MultiActionLinkCellRendererComponent,
    ExportComponent,
    CountryDropdownComponent,
    CheckboxCellRendererComponent,
    RspDropdownComponent,
    DateRangeComponent,
    ReceivingChannelDropdownComponent,
    TransactionStatusDropdownComponent,
    CompanyDropdownComponent,
    EmployeeDropdownComponent,
    ConfirmationModalComponent,
    ResultGridActionsComponent,
    CancelTransactionComponent,
    MultiActionLinkCellRendererComponent,
    MakerCheckerComponent,
    MakerCheckerSearchPanelComponent,
    MakerCheckerRequestDetailsPanelComponent,
    MakerCheckerFilterFormComponent,
    CustomDatePipe
  ],
  imports: [
    CommonModule,
    XBCCommonRoutingModule,
    ReactiveFormsModule,
    AgGridModule
  ],
  exports: [
    ResultGridComponent,
    CountryDropdownComponent,
    RspDropdownComponent,
    DateRangeComponent,
    ReceivingChannelDropdownComponent,
    TransactionStatusDropdownComponent,
    CompanyDropdownComponent,
    EmployeeDropdownComponent,
    ConfirmationModalComponent,
    ResultGridActionsComponent,
    CancelTransactionComponent,
    CustomDatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class XBCCommonModule { }
